import React from 'react';

const TIER_ORDER = { 'Well-Studied': 4, 'Moderate Evidence': 3, 'Thin Evidence': 2, 'No FDA Data': 1 };
const TIER_COLOR = { 'Well-Studied': '#2e7d32', 'Moderate Evidence': '#f57c00', 'Thin Evidence': '#c62828', 'No FDA Data': '#999' };

function winner(a, b, higherIsBetter = true) {
  if (a === b) return 'tie';
  return (higherIsBetter ? a > b : a < b) ? 'a' : 'b';
}

function Row({ label, valA, valB, win }) {
  return (
    <div className="cmp-row">
      <span className="cmp-metric">{label}</span>
      <span className={`cmp-val ${win === 'a' ? 'cmp-val--winner' : ''}`}>{valA}</span>
      <span className={`cmp-val ${win === 'b' ? 'cmp-val--winner' : ''}`}>{valB}</span>
    </div>
  );
}

function DrugComparison({ drug1, drug2, onSearch }) {
  if (!drug1 || !drug2) return null;

  const name1 = drug1.drugInfo?.brandName || drug1.name;
  const name2 = drug2.drugInfo?.brandName || drug2.name;

  const phase34_1 = drug1.trials.filter(t => t.phase === 'PHASE3' || t.phase === 'PHASE4').length;
  const phase34_2 = drug2.trials.filter(t => t.phase === 'PHASE3' || t.phase === 'PHASE4').length;
  const enroll1 = Math.max(...drug1.trials.map(t => t.enrollment), 0);
  const enroll2 = Math.max(...drug2.trials.map(t => t.enrollment), 0);
  const tier1 = TIER_ORDER[drug1.evidenceTier.label] || 0;
  const tier2 = TIER_ORDER[drug2.evidenceTier.label] || 0;

  const rows = [
    { label: 'Evidence Tier', valA: drug1.evidenceTier.label, valB: drug2.evidenceTier.label, win: winner(tier1, tier2) },
    { label: 'Total Trials', valA: drug1.trials.length, valB: drug2.trials.length, win: winner(drug1.trials.length, drug2.trials.length) },
    { label: 'Phase 3/4 Trials', valA: phase34_1, valB: phase34_2, win: winner(phase34_1, phase34_2) },
    { label: 'Largest Enrollment', valA: enroll1.toLocaleString(), valB: enroll2.toLocaleString(), win: winner(enroll1, enroll2) },
    { label: 'Recalls on Record', valA: drug1.recalls.length, valB: drug2.recalls.length, win: winner(drug1.recalls.length, drug2.recalls.length, false) },
    { label: 'Top FAERS Signal', valA: drug1.adverseEvents[0]?.count.toLocaleString() ?? '—', valB: drug2.adverseEvents[0]?.count.toLocaleString() ?? '—', win: 'tie' },
  ];

  return (
    <div id="comparison" className="result-section cmp-section">
      <h3>Side-by-Side Comparison</h3>

      <div className="cmp-header-row">
        <span className="cmp-metric" />
        <button className="cmp-drug-name" onClick={() => onSearch(drug1.name)}>
          <span style={{ color: TIER_COLOR[drug1.evidenceTier.label] }}>●</span> {name1}
        </button>
        <button className="cmp-drug-name" onClick={() => onSearch(drug2.name)}>
          <span style={{ color: TIER_COLOR[drug2.evidenceTier.label] }}>●</span> {name2}
        </button>
      </div>

      {rows.map((row, i) => (
        <Row key={i} {...row} />
      ))}

      <p className="cmp-note">✓ highlights the stronger value for each metric. Recalls: fewer is better.</p>
    </div>
  );
}

export default DrugComparison;
